
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funds/[fcik]",
      function () {
        return require("private-next-pages/funds/[fcik].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funds/[fcik]"])
      });
    }
  